<template>
  <v-container fluid class="fill-height d-flex justify-center align-center">
    <v-row class="ma-5 pa-5">
      <v-col cols="12" class="d-flex justify-center align-center">
        <div>
          <div v-if="!qrCode">
            <div class="text-center my-4">
              <v-btn color="#00B3FF" @click="generate2FA" :loading="loading">
                Generate 2FA QR Code
              </v-btn>
            </div>
            <div class="text-center my-5 d-none">
              <span
                v-if="!(verifying || loading)"
                class="text-mustardYellow cursor-pointer"
                @click="logout"
                >Logout</span
              >
            </div>
          </div>
          <div v-else>
            <div class="mb-4 text-center">
              <div class="mb-2 text-subtitle-2">
                Scan this QR code with your authenticator app:
              </div>
              <div v-html="qrCode" class="mb-2"></div>
              <div class="text-caption">
                Or enter this code manually: <b>{{ secret }}</b>
              </div>
            </div>
            <!-- Replace v-otp-input with a simple v-text-field for Vue 2 -->
            <v-otp-input
              v-model="otp"
              label="Enter 6-digit code"
              length="6"
              class="mt-3 ms-n2"
            ></v-otp-input>
            <div class="text-center my-4">
              <v-btn
                color="#00B3FF"
                @click="verify2FA"
                :loading="verifying"
                :disabled="loading"
              >
                Verify & Enable 2FA
              </v-btn>
            </div>
            <div class="text-center my-5 d-none">
              <span
                v-if="!(verifying || loading)"
                class="text-teal cursor-pointer"
                @click="logout"
                >Logout</span
              >
            </div>
          </div>
        </div>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2000">
          {{ text }}
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthService } from "@/services/auth-service.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      qrCode: "",
      secret: "",
      otp: "",
      loading: false,
      verifying: false,
      userId: this.$route.query.id,
      snackbar: false,
      snackbarColor: "",
      text: "",
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async generate2FA() {
      this.loading = true;
      try {
        const res = await AuthService.generate2FA(this.userId);
        this.qrCode = res.data.qr;
        this.secret = res.data.secret;
        this.snackbarColor = "success";
        this.text = "QR code generated!";
        this.snackbar = true;
      } catch (err) {
        this.snackbarColor = "warning";
        this.text = "Failed to generate 2FA QR code.";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
    async verify2FA() {
      this.verifying = true;
      try {
        await AuthService.verify2FA(this.userId, this.otp);
        this.snackbarColor = "success";
        this.text = "Two-factor authentication enabled!";
        this.snackbar = true;
        setTimeout(() => {
          this.$router.push("/login");
        }, 1500);
      } catch (err) {
        this.snackbarColor = "warning";
        this.text = "Invalid code. Please try again.";
        this.snackbar = true;
      } finally {
        this.verifying = false;
      }
    },
    async logout() {
      await this.logout();
      this.$router.push("/login");
    },
  },
};
</script>
